import ContactUs from "./Components/ContactUs";
import FAQ from "./Components/FAQ";
import HeroComponent from "./Components/HeroComponent";
import ManufacturerTesting from "./Components/ManufacturerTesting";
import Pricing from "./Components/Pricing";

const Home = () => {
  return (
    <div>
      <HeroComponent />
      <Pricing />
      <ManufacturerTesting />
      <FAQ />
      <ContactUs />
    </div>
  );
};

export default Home;
